module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Book.e2652d8d.woff";